import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import * as st from './DropSelect.module.scss'
import { Input, InputProps } from '../Input/Input'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

// Converting from base 10 to base 36 (https://en.wikipedia.org/wiki/Base36)
const baseRadix = 36

type SelectOptions = (InputProps & { text: string })[]

export interface DropSelectProps extends BaseComponentProps {
    selectOptions: SelectOptions
    selectName: string
    selectText?: string
    customDropSelectID?: string
}

export const DropSelect = (props: DropSelectProps) => {
    const { selectOptions, selectName, selectText, customDropSelectID } = props

    const dropSelectID =
        customDropSelectID ||
        Math.random()
            .toString(baseRadix)
            .slice(2)

    const className = extractClassNamesFromProps(props, st.dropselect)

    const labelTriggerClassName = cn(st['label-trigger'])

    const inputTriggerClassName = cn(st['input-trigger'])
    const dropSelectWrapper = cn(st.wrapper)

    let counter = 2

    const showInputs = selectOptions.map(selectOptionProps => [
        <Input
            key={selectOptionProps.value}
            type="radio"
            name={selectName}
            value={selectOptionProps.value}
            defaultChecked={selectOptionProps.checked}
            id={`${dropSelectID}-${counter}`}
        />,
        <label
            key={counter}
            className={cn(st['dropselect-item'])}
            htmlFor={`${dropSelectID}-${counter++}`}
        >
            {selectOptionProps.text}
        </label>,
    ])

    const showDefaultOption = () =>
        selectText && [
            <Input
                type="radio"
                name={selectName}
                key={`${dropSelectID}-1`}
                value="default"
                id={`${dropSelectID}-1`}
            />,
            <label key={`${dropSelectID}-l-1`} className={st.default} htmlFor={`${dropSelectID}-1`}>
                {selectText}
            </label>,
        ]

    return (
        <div className={className}>
            <div className={dropSelectWrapper}>
                <Input
                    type="radio"
                    className={inputTriggerClassName}
                    id={`${dropSelectID}-trigger`}
                    name={selectName}
                    value="trigger"
                />
                <label
                    className={labelTriggerClassName}
                    htmlFor={`${dropSelectID}-trigger`}
                />

                <div>
                    {showDefaultOption()}
                    {showInputs}
                </div>
            </div>
        </div>
    )
}
